import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '@/redux/store';

const stateSelector = (state: Partial<GlobalState>) => state;
const geoAreaSlice = createSelector(stateSelector, (state) => state.geoArea);

export const allGeoAreasSelector = createSelector(geoAreaSlice, ({ byId }) =>
    Object.keys(byId).map((key) => byId[Number(key)])
);
export const createGeoAreaByIdSelector = (id: number) => createSelector(geoAreaSlice, ({ byId }) => byId[id]);
export const createRelatedGeoAreasByIdSelector = (id: number) =>
    createSelector(geoAreaSlice, ({ byRelatedGeoAreasId }) => byRelatedGeoAreasId[id] || []);
export const addressBasedRelatedGeoAreaSelector = createSelector(
    geoAreaSlice,
    ({ addressBasedRelatedGeoArea }) => addressBasedRelatedGeoArea
);
